module.exports = __webpack_public_path__ + "img/circle_close.1bd31a23.svg";